import React from 'react';
import { Link } from 'react-router-dom';

interface InternalLinkBaseProps {
  to: string;
  className?: string;
  children: React.ReactNode;
}

export const InternalLinkBase = ({ to, children, className, ...passthroughProps }: InternalLinkBaseProps) => {
  return (
    <Link to={to} className={className} {...passthroughProps}>
      {children}
    </Link>
  );
};
